import JsvMetricsLogger from 'Utils/JsvMetricsLogger';
const LOCAL_STORAGE_KEY = 'rirekisho_should_skip_start_page';
export default class InitialPageUtil {
    static shouldSkipStartPage() {
        return localStorage.getItem(LOCAL_STORAGE_KEY) === '1';
    }
    static skipStartPageNextTime(buttonElement) {
        localStorage.setItem(LOCAL_STORAGE_KEY, '1');
        JsvMetricsLogger.log('click', 'tos_accepted', buttonElement);
    }
    static isInMaintenance() {
        return !!window.proctorGroups.univ_maintenance_tst;
    }
}
